import getRootNode$1 from 'get-root-node-polyfill';

function getRelatedTarget (event) {
  return event.relatedTarget || // when we explicitly set focus we can end up with events with no target or relatedTarget
  (getRootNode$1.call(event.target || event.path[0]) || document).activeElement;
}

export default getRelatedTarget;
